// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  box-sizing: border-box;
}

*, *::before, *::after {
  box-sizing: inherit;
  padding: 0;
  margin: 0;
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

.app {
  width: 960px;
  margin: 0 auto;
  padding: 20px;
}

.Auth-form-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.Auth-form {
  width: 420px;
  box-shadow: rgb(0 0 0 / 16%) 1px 1px 10px;
  padding-top: 30px;
  padding-bottom: 20px;
  border-radius: 8px;
  background-color: white;
}

.Auth-form-content {
  padding-left: 12%;
  padding-right: 12%;
}

.Auth-form-title {
  text-align: center;
  margin-bottom: 1em;
  font-size: 24px;
  color: rgb(34, 34, 34);
  font-weight: 800;
}

label {
  font-size: 14px;
  font-weight: 600;
  color: rgb(34, 34, 34);
}

nav ul {
  list-style: none;
  display: flex;
  background-color: black;
  margin-bottom: 20px;
}

nav ul li {
  padding: 20px;
}

nav ul li a {
  color: white;
  text-decoration: none;
}

h1 {
  margin-bottom: 20px;
}

p {
  margin-bottom: 15px;
}

.login-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.modal-header{
  text-align: center;
}

.floatRight{
  float: right;
}

.negrita{
  font-weight: bold;
}

.centrarText{
  text-align: center;
}

.modal-title span:nth-child(2) {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yCAAyC;EACzC,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["html {\n  box-sizing: border-box;\n}\n\n*, *::before, *::after {\n  box-sizing: inherit;\n  padding: 0;\n  margin: 0;\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n.app {\n  width: 960px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.Auth-form-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.Auth-form {\n  width: 420px;\n  box-shadow: rgb(0 0 0 / 16%) 1px 1px 10px;\n  padding-top: 30px;\n  padding-bottom: 20px;\n  border-radius: 8px;\n  background-color: white;\n}\n\n.Auth-form-content {\n  padding-left: 12%;\n  padding-right: 12%;\n}\n\n.Auth-form-title {\n  text-align: center;\n  margin-bottom: 1em;\n  font-size: 24px;\n  color: rgb(34, 34, 34);\n  font-weight: 800;\n}\n\nlabel {\n  font-size: 14px;\n  font-weight: 600;\n  color: rgb(34, 34, 34);\n}\n\nnav ul {\n  list-style: none;\n  display: flex;\n  background-color: black;\n  margin-bottom: 20px;\n}\n\nnav ul li {\n  padding: 20px;\n}\n\nnav ul li a {\n  color: white;\n  text-decoration: none;\n}\n\nh1 {\n  margin-bottom: 20px;\n}\n\np {\n  margin-bottom: 15px;\n}\n\n.login-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.modal-header{\n  text-align: center;\n}\n\n.floatRight{\n  float: right;\n}\n\n.negrita{\n  font-weight: bold;\n}\n\n.centrarText{\n  text-align: center;\n}\n\n.modal-title span:nth-child(2) {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
